export class Questionario{
    id:number;
	descricao:string;
    //enum
    tipoQuestionario:string;
	dataFim:string;
	dataInicio:string;
	usuarioAlteracao:number;
}